/* Continue to the thank you page only from Shopify's rendered success state, after ow-tracking.js
   has had the chance to record the Lead. The visible "What happens next" link works without script. */
(function () {
  'use strict';
  var marker = document.querySelector('[data-ow-funnel-success]');
  if (!marker) return;
  var destination = marker.getAttribute('data-ow-funnel-success');
  if (!destination || destination.charAt(0) !== '/' || destination.charAt(1) === '/') return;
  var form = marker.closest('form');
  var attempts = 0;
  function ready() {
    var tracker = document.querySelector('script[src*="ow-tracking.js"]');
    if (!tracker) return true;
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.marketingAllowed !== 'function' || typeof privacy.saleOfDataAllowed !== 'function') return false;
    if (!privacy.marketingAllowed() || !privacy.saleOfDataAllowed()) return true;
    try {
      var pending = JSON.parse(window.sessionStorage.getItem('ow-meta-pending-v1') || '{}');
      var key = window.location.pathname + ':' + (form ? form.id : 'start-form');
      return !pending[key] && !!window.fbq && typeof window.fbq.callMethod === 'function';
    } catch (error) { return false; }
  }
  function next() {
    if (ready()) window.setTimeout(function () { window.location.assign(destination); }, 250);
    else if (++attempts < 100) window.setTimeout(next, 100);
  }
  if (document.readyState === 'complete') next();
  else window.addEventListener('load', next, { once: true });
})();
